import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

@Component({
  selector: 'ddc-tag-s',
  templateUrl: './ddc-tag-s.component.html',
  styleUrl: './ddc-tag-s.component.scss',
  imports: [CommonModule],
})
export class DdcTagSComponent {
  @Input('tags') _tags: any[]
}
